export const productModalFormInit = () => {
  if(document.querySelector('.modal-product-form')) {
    const modalForm = document.querySelector('.modal-product-form');
    const modalFormClose = modalForm.querySelector('.modal-form__close');
    const modalFormProductField = modalForm.querySelector('.ag-product-title');
    const modalProductTitle = modalForm.querySelector('.product-title');
    const tileProducts = document.querySelectorAll('.tile-product');

    if(tileProducts) {
      tileProducts.forEach((tileProduct) => {
        const productTitle = tileProduct.querySelector('.tile-product-title');
        const modalFormTrigger = tileProduct.querySelector('.tile-product-modal-trigger');
        
        if(modalFormTrigger) {
          modalFormTrigger.addEventListener('click', (e) => {
            if(productTitle) {
              modalProductTitle.innerHTML = productTitle.innerText;
              modalFormProductField.value = productTitle.innerText;
            }
            modalForm.style.display = 'block';
            document.body.classList.add('modal-open');
          });
        }
      });
    }

    if(modalFormClose) {
      modalFormClose.addEventListener('click', (e) => {
        modalForm.style.display = 'none';
        document.body.classList.remove('modal-open');
        modalProductTitle.innerHTML = '';
        modalFormProductField.value = '';
      });
    }

    document.addEventListener('click', (e) => {
      if(!e.target.closest('.modal-form__inner') && !e.target.matches('.tile-product-modal-trigger')) {
        modalForm.style.display = 'none';
        document.body.classList.remove('modal-open');
      }
    });
  }
}